import { logbookRoutesMESF } from "@dexteel/mesf-core";
import { Route } from "react-router-dom";

// Convert MESF Core route config objects to JSX Route elements
export const LogbookRoutes = logbookRoutesMESF.map((route, index) => (
	<Route
		key={`logbook-${route.path}-${index}`}
		path={route.path}
		element={route.element}
	/>
));
